import { Navigate, useParams } from "react-router-dom";
import { skipToken } from "@reduxjs/toolkit/query";

import { useGetCertificationQuery } from "@/redux/service";
import OverviewSkeleton from "@/features/certifications/overview/components/OverviewSkeleton";
import { useCertificationProgress } from "@/domains/certifications/hooks/useCertificationProgress";
import { certificationPaths } from "@/domains/certifications/routes";
import {
  isNotEnrolledError,
  isRemovedFromCertificationError,
} from "@/domains/certifications/utils";
import CertificationOverview from "@/features/certifications/overview";
import { ENROLLMENT_STATES } from "@/domains/certifications/constants";

const CertificationOverviewPage = () => {
  const { slug } = useParams();
  const {
    data: certification,
    error,
    isError,
    isFetching,
  } = useGetCertificationQuery(slug ?? skipToken);
  const { data: progress, isError: isProgressError } =
    useCertificationProgress(certification);
  const isEnrolled =
    certification?.enrollment?.state === ENROLLMENT_STATES.ACTIVE;

  if (
    slug &&
    (isNotEnrolledError(error) || isRemovedFromCertificationError(error))
  ) {
    return <Navigate to={certificationPaths.details(slug)} replace />;
  }

  if (!slug || isError || (isProgressError && !progress)) {
    return <Navigate to="/" replace />;
  }

  if (certification && !isEnrolled && !isFetching) {
    return <Navigate to={certificationPaths.details(slug)} replace />;
  }

  if (!certification || !progress) {
    return <OverviewSkeleton />;
  }

  return (
    <CertificationOverview certification={certification} progress={progress} />
  );
};

export default CertificationOverviewPage;
